import {mapValues} from 'lodash';
import {createSelector} from 'reselect';
import {baseRequiredFields} from '../../constants/requiredfields';

export const getRequiredFields = state => state.requiredFields.fields.merge(baseRequiredFields);

export const getRequiredFieldsFormatted = createSelector(
  getRequiredFields,
  requiredFields => mapValues(requiredFields, 'isRequired')
);

export const isUpdatingRequiredFields = state => state.requiredFields.isUpdating;

export const isLoadingRequiredFields = state => state.requiredFields.loading;
